import { render, staticRenderFns } from "./veneers-table.vue?vue&type=template&id=6991391d&scoped=true"
import script from "./veneers-table.vue?vue&type=script&lang=js"
export * from "./veneers-table.vue?vue&type=script&lang=js"
import style0 from "./veneers-table.vue?vue&type=style&index=0&id=6991391d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991391d",
  null
  
)

export default component.exports